export default __webpack_public_path__ + "static/media/9.dca9cbc6.png";